import { render, staticRenderFns } from "./InvoiceUpdateItemForm.vue?vue&type=template&id=48dc584a&"
import script from "./InvoiceUpdateItemForm.vue?vue&type=script&lang=js&"
export * from "./InvoiceUpdateItemForm.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceUpdateItemForm.vue?vue&type=style&index=0&id=48dc584a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports